var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimplazBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4.54545,
    fill: "#EFF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_920_2831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4639 12C21.665 12 19.3904 14.2677 19.3904 17.0541V22.1083H32.9264C35.7254 22.1083 38.0033 19.8406 38.0033 17.0541V12H24.4639ZM36.3088 17.0541C36.3088 18.9107 34.7913 20.4247 32.9264 20.4247H21.0816V17.0541C21.0816 15.1976 22.599 13.6836 24.4672 13.6836H36.3121V17.0541H36.3088Z",
    fill: "url(#paint0_linear_920_2831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 28.8949V33.9491C11 36.7323 13.2779 39 16.0768 39H38.0033V33.9458C38.0033 31.1594 35.7254 28.8917 32.9264 28.8917L11 28.8949ZM12.6912 30.5786H32.9232C34.7881 30.5786 36.3088 32.0893 36.3088 33.9491V37.3196H16.0768C14.2119 37.3196 12.6945 35.8089 12.6945 33.9491V30.5786H12.6912Z",
    fill: "url(#paint1_linear_920_2831)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_920_2831",
    x1: 12.6868,
    y1: 17.0534,
    x2: 33.3049,
    y2: 17.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1155BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_920_2831",
    x1: 12.0526,
    y1: 33.9467,
    x2: 35.0708,
    y2: 33.9467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1155BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB2EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_920_2831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplazBlueIcon);
export default __webpack_public_path__ + "static/media/simplaz-blue-icon.217372fa4b59e774143989d292bd13d0.svg";
export { ForwardRef as ReactComponent };